// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3240":"support","4303":"widget","6472":"settings"}[chunkId] + ".chunk.min.css";
};